import React from 'react';
import Container from 'evcharging/components/Container';
import Spacer from 'evcharging/components/Spacer';
import Responsible from 'evcharging/components/Responsible';
import Section from 'evcharging/containers/layout/Section';
import Title from 'evcharging/components/Title';
import smartEnergy from 'evcharging/assets/open-adr/smartEnergy.png';
import Box from 'evcharging/components/Box';
import Baget from 'evcharging/components/Baget';
import Paragraph from 'evcharging/components/Paragraph';
import { CONTACT_US_ANCHOR } from 'evcharging/app/seo/urls';
import LinkButton from 'evcharging/components/LinkButton';
import useI18n from 'evcharging/hooks/useI18n';
import Image from 'next/image';

const SmartEnergy = () => {
  const { t } = useI18n();

  return (
    <Section>
      <Container>
        <Responsible fractions={[44, 52]} maxWidth={1100} margin={'0 auto'}>
          <Image src={smartEnergy} alt={'how it works'} width={495} height={492} />
          <Box>
            <Baget>{t('open.smart.label')}</Baget>
            <Spacer value={16} />
            <Title variant={'h2'}>{t('open.smart.title')}</Title>
            <Spacer value={12} />
            <Paragraph color={'middle'}>{t('open.smart.body')}</Paragraph>
            <Spacer value={24} />
            <LinkButton href={CONTACT_US_ANCHOR}>{t('ocpp.schedule')}</LinkButton>
          </Box>
        </Responsible>
      </Container>
    </Section>
  );
};

export default SmartEnergy;
